import React from 'react';
import TryThisOut from '../../pages/tryNow/TryThisOut';

function MalaysianDLOCR({ currentProduct }) {
  return (
    <>
      <TryThisOut currentProduct={currentProduct} />
    </>
  );
}

export default MalaysianDLOCR;
